import schema from "venuescanner-js/schemas/inboxSchema.json";
import builder from "./builder";
const models = {};
// console.log(schema)
Object.keys(schema).forEach((key) => {
  models[key] = class {
    constructor(props = {}) {
      builder(this, key, schema[key], props);
    }
  };
});
export default models;
